const semanticClassNames = {
  root: 'social-player-youtube',
} as const;

export default semanticClassNames;
